<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <h5 class="p-3">تعیین کاربرانی که هنگام ثبت، فقط به آنها تیکت ارجاع شود</h5>
          <p>* تنظیمات این قسمت، فقط هنگام ثبت تیکت از طرف مشتری مشخص شده به بخش مشخص شده، اعمال میشوند.</p>
          <p>* کاربران هدف باید به ازای هر بخش و مشتری، جداگانه مشخص شوند.</p>
          <p>* در صورت مشخص کردن حداقل یک کاربر هدف در این قسمت، نقش‌ها و کاربران پیشفرض بخش نادیده گرفته میشوند.</p>
          <p>* در صورتی که کاربری تعین نشده باشد، نقش‌ها و کاربران پیشفرض بخش، هدف ارجاع تیکت هنگام ثبت در نظر گرفته می‌شوند.</p>
          <hr class="horizontal dark" />
          <div class="col-md-6">
            <label class="form-control-label" for="sectionSearch">بخش</label>
            <vue-select v-model="section" :options="sectionsList" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
          <div class="col-md-6">
            <label class="form-control-label" for="customerSearch">مشتری</label>
            <vue-select v-model="customer" :options="customersList" dir="rtl" label="title">
              <template #no-options="{ search, searching, loading }">
                موردی یافت نشد!
              </template>
            </vue-select>
          </div>
        </div>
        <hr class="horizontal dark" />
        <member-users-manager :usersList="usersList" :memberUsers="memberUsersList.filter(u => !u.isDeleted)"
          :companyId="companyId" @addUser="addUser" @removeUser="removeUser" />
        <hr class="horizontal dark" />
        <template v-if="v.$error">
          <show-errors :model-value="v.$errors"></show-errors>
          <hr class="horizontal dark" />
        </template>
        <button type="button" class="btn bg-gradient-success mb-0" @click="submit()">ثبت تغییرات</button>
        <button class="btn bg-gray-400 me-3 float-start mb-0" type="button" @click="goBack()">بازگشت</button>
      </div>
    </div>
  </div>
</template>
<script>
import CompanySectionService from '@/services/Company/CompanySectionService.js';
import CompanyService from '@/services/Company/Company-service.js';
import CustomerService from '@/services/Company/Customer-service.js';
import UserService from '@/services/User/User-service.js';
import MemberUsersManager from "@/views/components/MemberUsersManager.vue";
import { helpers, required } from '@vuelidate/validators';

export default {
  components: { MemberUsersManager },
  data() {
    return {
      v: this.$useVuelidate(),
      companyId: null,
      sectionId: null,
      sectionsList: [],
      section: null,
      customersList: [],
      customer: null,
      usersList: [],
      memberUsersList: [],
      sectionsLoaded: false,
    };
  },
  watch: {
    companyId() {
      this.section = null;
      this.sectionsList = [];
      this.usersList = [];
      this.getSectionsByCompanyId();
      this.getUsersByCompany();
    },
    section() {
      this.customer = null;
      this.customersList = [];
      this.memberUsersList = [];
      this.getCustomersByCompanySectionId();
    },
    customer() {
      this.memberUsersList = [];
      this.getListCompanyReferralBases();
    },
  },
  methods: {
    getSectionsByCompanyId() {
      if (this.companyId > 0) {
        CompanyService.getSectionsByCompanyId(this.companyId).then(response => {
          let result = response.data;

          if (result.success) {
            this.sectionsList = result.data;

            if (this.sectionId > 0) {
              this.section = this.sectionsList.find(cs => cs.id == this.sectionId);

              this.sectionId = null;
            }
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
    },
    getUsersByCompany() {
      if (this.companyId > 0) {
        UserService.getListByCompanyId(this.companyId).then(response => {
          let result = response.data;

          if (result.success) {
            this.usersList = result.data;
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
    },
    getCustomersByCompanySectionId() {
      if (this.section?.id > 0) {
        CustomerService.getCustomersByCompanySectionId(this.section.id).then(response => {
          let result = response.data;

          if (result.success) {
            this.customersList = result.data;
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
    },
    getListCompanyReferralBases() {
      if (this.section?.id > 0 & this.customer?.id > 0) {
        CompanySectionService.getListCompanyReferralBases(this.section.id, this.customer.id).then(response => {
          let result = response.data;

          if (result.success) {
            this.memberUsersList = result.data.filter(crb => crb?.user != null).map(crb => crb.user);
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }
    },
    addUser(user) {
      if (this.memberUsersList.findIndex(u => u.id == user.id) < 0) {
        this.memberUsersList.push({ ...user, isNew: true });
      }
      else {
        this.memberUsersList.find(u => u.id == user.id).isDeleted = false;
      }
    },
    removeUser(user) {
      this.memberUsersList.find(u => u.id == user.id).isDeleted = true;
    },
    submit() {
      this.v.$validate();
      if (this.v.$error) {
        return;
      }

      if (this.section?.id > 0 & this.customer.id > 0) {
        let model = {
          CompanySectionId: this.section.id,
          CustomerId: this.customer.id,
          ToBeAddedUsersIds: this.memberUsersList.filter(u => u.isNew & !u.isDeleted).map(u => u.id),
          ToBeAddedRolesIds: [],
          ToBeRemovedUsersIds: this.memberUsersList.filter(u => !u.isNew & u.isDeleted).map(u => u.id),
          ToBeRemovedRolesIds: [],
          DeleteReason: null,
        }

        CompanySectionService.godifyRangeCompanyReferralBases(model).then(response => {
          let result = response.data;

          if (result.success) {
            this.$toast.success(result.message);

            this.getListCompanyReferralBases();
          }
          else {
            this.$toast.error(result.message);
          }
        }).catch(e => {
          console.log(e);
        });
      }

      this.v.$reset();
    },
    goBack() {
      this.$router.back();
    }
  },
  created() {
    this.companyId = this.$route.query.companyId;
    this.sectionId = this.$route.query.sectionId;
  },
  validations() {
    let valObj = {
      section: {
        required: helpers.withMessage('لطفا "بخش" را انتخاب کنید', required),
      },
      customer: {
        required: helpers.withMessage('لطفا "مشتری" را انتخاب کنید', required),
      },
    };

    return valObj;
  },
}
</script>
